var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewRosters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 18,
    viewBox: "0 0 35 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6402 17.0429H9.0105C9.0105 12.4549 12.7374 8.72803 17.3254 8.72803C21.9134 8.72803 25.6402 12.4549 25.6402 17.0429Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9816 4.2954C20.9816 6.31412 19.3441 8.72811 17.3395 8.72811C16.7889 8.72811 16.2807 8.54459 15.8148 8.24813C15.4196 7.99403 15.0666 7.66934 14.7843 7.28818L14.7561 7.25995C14.0926 6.39882 13.6832 5.2977 13.6832 4.28128C13.6832 3.26486 14.0643 2.3755 14.7561 1.69789C15.4478 1.02027 16.3654 0.625 17.3395 0.625C19.3582 0.625 20.9816 2.26256 20.9816 4.28128V4.2954Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8615 9.09572C24.9344 8.29105 26.2613 7.8252 27.7013 7.8252C31.2446 7.8252 34.1103 10.6909 34.1103 14.2343H28.3506",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5247 4.39423C30.5247 5.94709 29.2683 7.81052 27.7154 7.81052C27.2919 7.81052 26.8966 7.66935 26.5437 7.44348C26.2331 7.24584 25.9649 6.99174 25.7531 6.7094H25.739C25.2308 6.03179 24.9202 5.18477 24.9202 4.39423C24.9202 3.60368 25.2167 2.92607 25.739 2.40374C26.2614 1.88142 26.9813 1.58496 27.7295 1.58496C29.2824 1.58496 30.5388 2.85548 30.5388 4.39423H30.5247Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22941 14.2201H0.625C0.625 10.6768 3.49073 7.81104 7.03408 7.81104C8.37519 7.81104 9.61747 8.22043 10.648 8.92627",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84334 4.39423C9.84334 5.94709 8.58694 7.81052 7.03408 7.81052C6.61057 7.81052 6.2153 7.66935 5.86238 7.44348C5.5518 7.24584 5.28358 6.99174 5.07183 6.7094H5.05771C4.5495 6.03179 4.23893 5.18477 4.23893 4.39423C4.23893 3.60368 4.53538 2.92607 5.05771 2.40374C5.58004 1.88142 6.3 1.58496 7.0482 1.58496C8.60106 1.58496 9.85746 2.85548 9.85746 4.39423H9.84334Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRosters);
export default __webpack_public_path__ + "static/media/newRosters.83624c2d1b52f33f16934c07ff644132.svg";
export { ForwardRef as ReactComponent };